import React, {useEffect} from 'react';
import CallBackResultComponent from './CallBackResultComponent';
import ErrorWithCallBackComponent from '../Errors/ErrorWithCallBackComponent';

const CallBackActionComponent = ({props, callBackRequest, backToPrivateArea, startOver}) => {
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  return props.data.callBackRequestSent ? (
    <CallBackResultComponent props={props} backToPrivateArea={backToPrivateArea} startOver={startOver} />
  ) : (
    <ErrorWithCallBackComponent
      props={props}
      changeHandler={props.changeCallbackHandler}
      callBackRequest={callBackRequest}
      startOver={startOver}
      saveToHistory={props.saveToHistory}
    />
  );
};

export default CallBackActionComponent;
